<template>
  <div class="header">
    <div class="nav-content">
      <div class="nav-logo">
        <a href="/" class="logo">
          <img src="./images/logo@2x.png" />
        </a>
      </div>
      <div class="navigation">
        <ul class="nav">
          <li>
            <a href="/?keyfrom=Nav-home" :class="{active:location=='?keyfrom=Nav-home'}">首页</a>
          </li>
          <li>
            <a
              href="/?path=fast&keyfrom=Nav-fast"
              :class="{active:location=='?path=fast&keyfrom=Nav-fast'}"
            >快速翻译</a>
          </li>
          <li class="arrow">
            <a
              href="/?path=file&keyfrom=Nav-doc"
              :class="{active:location=='?path=file&keyfrom=Nav-doc'}"
            >文档翻译</a>
            <span class="pointer"></span>
            <ul class="docTrans">
              <li v-for="(item,index) in docTrans" :key="index">
                <a :href="item.path">{{item.name}}</a>
              </li>
            </ul>
          </li>
          <li>
            <a
              href="/?path=localTrans&keyfrom=Nav-localTrans"
              :class="{active:location=='?path=localTrans&keyfrom=Nav-localTrans'}"
            >本地化翻译</a>
          </li>
          <li>
            <a
              href="/?path=paperPolish&subjectTab=medical&page=1"
              :class="{active:location=='?path=paperPolish&subjectTab=medical&page=1'}"
            >母语润色</a>
          </li>
          <li class="arrow">
            <a
              href="/?path=about&keyfrom=Nav-about"
              :class="{active:location=='?path=about&keyfrom=Nav-about'}"
            >更多</a>
            <span class="pointer"></span>
            <ul class="more">
              <li v-for="(item,index) in moreList" :key="index">
                <a :href="item.path">{{item.name}}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="account">
        <div class="noLogin" v-if="!login">
          <a :href="url">登录</a>
          <a
            href="https://zc.reg.163.com/regInitialized?pd=dict_hts&pkid=JitlhLr&pkht=f.youdao.com#/"
          >注册</a>
        </div>
        <div class="login" v-else>
          <div>
            <a href="/user.s?method=translateResult">我的订单</a>
          </div>

          <div class="myLogin arrow">
            <a>个人中心</a>
            <span class="pointer"></span>
            <ul class="mine">
              <li class="icon" :title="username">{{username}}</li>
              <li>
                <a href="/user.s?method=userChargeResult">我的账户</a>
              </li>
              <li>
                <a href="/user.s?method=getUserInfo">联系方式</a>
              </li>
              <li>
                <a href="/userBill.do?method=applyBill">申请发票</a>
              </li>
              <li>
                <a href="logout.do">退出</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      // isActive: false,
      location: '',
      navList: [
        {
          name: '首页',
          path: '/?keyfrom=Nav-home'
        },
        {
          name: '快速翻译',
          path: '/?path=fast&keyfrom=Nav-fast'
        },
        {
          name: '文档翻译',
          path: '/?path=file&keyfrom=Nav-doc'
        },
        {
          name: '本地化翻译',
          path: '/?path=localTrans&keyfrom=Nav-localTrans'
        },
        {
          name: '母语润色',
          path: '/?path=paperPolish&subjectTab=medical&page=1'
        },
        {
          name: '更多',
          path: '/?path=about&keyfrom=Nav-about'
        }
      ],
      docTrans: [
        {
          name: '专业论文',
          path: '/?path=thesis&keyfrom=Nav-thesis'
        },
        {
          name: '产品介绍',
          path: '/?path=intro&keyfrom=Nav-intro'
        },
        {
          name: '合同标书',
          path: '/?path=contract&keyfrom=Nav-contract'
        },
        {
          name: '简历介绍',
          path: '/?path=cv&keyfrom=Nav-cv'
        },
        {
          name: '证件翻译',
          path: '/?path=credential&keyfrom=Nav-credential'
        },
        {
          name: '留学移民',
          path: '/?path=abroad&keyfrom=Nav-abroad'
        },
        {
          name: '创意翻译',
          path: '/?path=creativeTrans&keyfrom=Nav-creative'
        },
        {
          name: '母语润色',
          path: '/?path=paperPolish&subjectTab=medical&page=1'
        }
      ],
      moreList: [
        {
          name: '口译服务',
          path: '/?path=interpret&keyfrom=Nav-interpret'
        },
        {
          name: '人工翻译API',
          path: '/?path=api&keyfrom=Nav-api#/'
        },
        {
          name: '译后编辑',
          path: '/?path=pe&keyfrom=Nav-pe'
        },
        {
          name: 'VIP服务',
          path: '/?path=vip&keyfrom=Nav-vip'
        },
        {
          name: '查看报价',
          path: '/?path=about&keyfrom=Nav-about1'
        },
        {
          name: '了解我们',
          path: '/?path=introduce&keyfrom=Nav-introduce'
        }
      ],
      current: 0,
      url: ''
    }
  },
  props: {
    login: {
      default: false,
      type: Boolean,
      required: true
    },
    username: {
      default: '用户名',
      type: String,
      required: true
    }
  },
  created () {
    // const baseUrl="http://hts-test-zhaoyh.inner.youdao.com/"
    const backUrl =
      '/login.do?back_url=' + encodeURIComponent(window.location.href)
    // window.location.href = backUrl;
    this.url = backUrl
  }
}
</script>
<style scoped>
.header {
  width: 100%;
  height: 55px;
  line-height: 55px;
  min-width: 960px;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 1px;
  box-shadow: 0px 1px 10px #e5e5e5;
  font-size: 14px;
}
.nav-content {
  width: 1030px;
  height: 55px;
  margin: 0 auto;
}
.logo {
  /* background: url(./images/logo_large.png) 0 50% no-repeat; */
  float: left;
  width: 219px;
  height: 55px;
  line-height: 55px;
  padding: 0;
}
img {
  width: 100%;
  margin-top: 13px;
}
.navigation {
  height: 55px;
  line-height: 55px;
  float: left;
}
.account a {
  margin-left: 17px;
}
.nav > li {
  float: left;
  margin: 0 21px;
}
.nav > li > a {
  font-size: 14px;
}
li a {
  float: left;
}
a:hover {
  color: #989898;
}
.arrow {
  position: relative;
}
.arrow:hover .pointer {
  transform: rotate(180deg);
}
.pointer {
  background: url(images/down.png) 0 0 no-repeat;
  width: 13px;
  height: 6px;
  float: left;
  margin-top: 24px;
  margin-left: 3px;
}
.account {
  float: right;
}
.account a {
  font-size: 14px;
}

.icon {
  padding: 0 10px;
  font-size: 14px;
}
.active {
  color: #fc3a4e;
  border-bottom: 2px solid #fc3a4e;
}
.docTrans {
  width: 168px;
  position: absolute;
  top: 55px;
  left: -40px;
  border-radius: 2px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  visibility: hidden;
  z-index: 999;
  background: white;
  font-size: 12px;
}
.docTrans li {
  width: 50%;
  float: left;
  height: 36px;
  line-height: 36px;
  text-align: center;
}
.more {
  position: absolute;
  left: -30px;
  top: 55px;
  width: 104px;
  border-radius: 2px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  visibility: hidden;
  z-index: 999;
  background: white;
  font-size: 12px;
}
.more a,
.docTrans a {
  float: none;
}
.more a:hover,
.docTrans a:hover,
.mine a:hover {
  color: #fc3a4e;
}
.arrow li:hover {
  background-color: #f5f5f5;
  transition: all 0.384s ease-in;
}
.more li {
  height: 36px;
  line-height: 36px;
  text-align: center;
}
.arrow:hover .more,
.arrow:hover .docTrans,
.arrow:hover .mine {
  visibility: visible;
}
.login div {
  float: left;
  margin-right: 13px;
}
.login a {
  float: left;
}
.myLogin {
  position: relative;
  padding-right: 16px;
}
.mine {
  position: absolute;
  z-index: 999;
  background: white;
  top: 55px;
  width: 104px;
  border-radius: 2px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  visibility: hidden;
  font-size: 12px;
}
.mine li {
  height: 38px;
  line-height: 38px;
  text-align: center;
}
.mine a {
  float: none !important;
  margin: 0;
}
.account .pointer {
  transition: all 0.384s ease-in;
}
.icon {
  border-bottom: 1px solid #e2e2e2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (min-width: 1279px) {
  .nav-content {
    width: 1200px;
  }
  .logo {
    margin-right: 64px;
  }
}
</style>
<style>
* {
  margin: 0;
  padding: 0;
  /* font-size: 12px; */
  font-family: "微软雅黑", Arial, sans-serif;
  color: #434343;
}

a {
  text-decoration: none;
  color: #333;
  cursor: pointer;
}
ul {
  list-style: none;
}
</style>
